import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Subject } from 'rxjs';
import { ReportProvider } from 'src/app/providers';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';
import { ToasterService } from 'src/app/services';

@Component({
  selector: 'app-ist-excel-paste',
  templateUrl: './ist-excel-paste.component.html',
  styleUrls: ['./ist-excel-paste.component.scss']
})
export class IstExcelPasteComponent implements OnInit, OnDestroy {
  subject: Subject<string>;
  versionId: string = '';

  docsDownloadUrl = environment.ASSETS_URL + 'assets/file/Valzy_How_To.docx';

  subscription: any;

  constructor(public bsModalRef: BsModalRef,
    private reportProvider: ReportProvider,
    private toastr: ToasterService,
    private modalService: BsModalService,
    private renderer: Renderer2) {
      renderer.listen('document', 'paste', (event: ClipboardEvent) => {
        this.handlePaste(event);
      });
    }

  ngOnInit(): void {
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if(reason === 'esc')
        this.decline();
    });
  }

  ngOnDestroy(): void {
    if(this.subscription)
      this.subscription.unsubscribe();
  }

  decline(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }

  handlePaste(event: ClipboardEvent): void {
    event.preventDefault();
    let data;

    if ((<any>window).clipboardData && (<any>window).clipboardData.getData) // IE
      data = (<any>window).clipboardData.getData('Text');
    else if (event.clipboardData && event.clipboardData.getData)
      data = event.clipboardData.getData("text/plain");

    this.bsModalRef.hide();
    this.subject.next(data);
    this.subject.complete();
  }

  downloadSampleFile() {
    this.reportProvider.downloadIsTemplate(this.versionId)
      .subscribe(
        response => {
          this.saveToFileSystem(response);
        }, error => {
          console.error(error);
        });
  }

  private saveToFileSystem(response) {
    const blob = new Blob([response], { type: 'text/xlsx' });
    saveAs(blob, 'Valzy_Import_Template.xlsx');
  }

}
